const id_mitra_stock_req = {
    "": "permintaan barang",
    detail: "detail permintaan barang",
    add: "tambah permintaan barang",
    edit: "ubah permintaan barang",

    label: {
        choose_mitra: "pilih mitra / depo / HQ",
        date: 'Tanggal Target Dikirim',
    },
}

export default id_mitra_stock_req;